<template>
  <div>
    
  <router-view></router-view>  
  
    <addproductmodal/>
    <addshopmodal/>
    <addsuppliermodal/>
    <addcustomermodal/>
  </div>
</template>

<script>
/*window.onbeforeunload = function() {
  return "Data will be lost if you leave the page, are you sure?";
};
if (window.performance) {
  alert('hi')
  console.log("window.performance work's fine on this browser");
};
if (performance.navigation.type == 1) {
  alert('hi1')
  console.info( "This page is reloaded" );
}else {
  console.info( "This page is not reloaded");
};*/

export default {
  name: 'app',
  created(){
  },
  methods: {
    
  }
}
</script>

<style>
  /* Import Font Awesome Icons Set */
  @import '~flag-icon-css/css/flag-icon.min.css';
  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/css/font-awesome.min.css';
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/css/simple-line-icons.css';
  /* Import Bootstrap Vue Styles */
  @import '~bootstrap-vue/dist/bootstrap-vue.css';
</style>
<style lang="scss">
  // Import Main styles for this application
  @import './scss/style';
  @import "~vue-snotify/styles/dark";
 
</style>



// WEBPACK FOOTER //
// src/App.vue